import { Permission } from 'shared'
import { CreateHeaderActionOptions } from '../../../../../../../../../../components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  RequestForInformation,
  useRFITrackerContext,
} from '../../../RFITrackerContext'

export function useCreateOptions(): CreateHeaderActionOptions<RequestForInformation> {
  const {
    fetching,
    draftSubmitModal: { toggle },
  } = useRFITrackerContext()

  return {
    loading: fetching,
    entity: 'Request For Information',
    permission: Permission.CreateRequestForInformation,
    modal: { type: 'custom', toggle },
  }
}
